<template>
  <div class="loader-backdrop" :class="{ inline: isInLine }">
    <div class="loader-core">
      <div class="loader-background">
        <div v-if="loaderImage" class="loader-image">
          <img :src="loaderImage" alt="loader-image" />
        </div>
        <template v-else>
          <div v-loading="true"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @param Loader
 *
 * @description A felületen a betöltést jelző loader megjelenítése
 */
import { get } from 'lodash'
import file from '../utils/file'

export default {
  name: 'Loader',
  props: {
    isInLine: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaderImage: '',
    }
  },
  mounted() {
    const loaderImg = get(this.$CORE, 'subSystem.loaderImage', null)
    this.loaderImage = loaderImg ? file.methods.getStaticImageSource(loaderImg) : '/static/loader.gif'
  },
}
</script>

<style lang="scss" scoped>
/* @todo refactor these to a global scope later */
@import '../../node_modules/bootstrap/scss/_functions.scss';
@import '../../node_modules/bootstrap/scss/_variables.scss';
.loader-backdrop {
  display: flex;
  position: absolute;
  z-index: $zindex-fixed;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.3s;
}
.loader-backdrop.inline {
  position: relative;
  min-height: 100px;
  max-height: 200px;
}
.loader-core {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}
.loader-backdrop.inline .loader-doto {
  display: flex;
  flex-grow: 1;
  justify-content: center;
}
.loader-background {
  background-color: #fff;
  position: relative;
  border-radius: 50%;
}
.loader-image {
  width: inherit;
  height: inherit;
  margin: 0 auto;
}
.loader-image > img {
  width: inherit;
  height: inherit;
  padding: 0.3rem;
  max-width: 200px;
  max-height: 200px;
}
</style>
